import { createRoot } from 'react-dom/client'
import React from 'react'
import { IntlProvider } from 'react-intl'
import translatedMessages from './locales/translations'
import { observer } from 'mobx-react-lite'
import { StoreProvider } from './store/storeProvider'
import { useStore } from './store/useStore'
import Init from './sections/init/init/Init'
// для автоматического поиска ключей для перевода
// eslint-disable-next-line no-unused-vars
import dynamicMessages from './locales/dynamicMessages'
import { jssPreset, StylesProvider, ThemeProvider } from '@material-ui/core/styles'
import theme from './App.theme'
import { create } from 'jss'
import rtl from 'jss-rtl'
import { configure } from 'mobx'

// TODO update package json versions
// TODO tracker tests
// TODO groups tests
// TODO persons tests

configure({ enforceActions: 'never', isolateGlobalState: true })

const App = observer(() => {
  const { localeStore } = useStore()

  const jss = create({ plugins: [...jssPreset().plugins, rtl()] })

  return (
    <IntlProvider
      locale={localeStore.locale}
      messages={translatedMessages[localeStore.locale]}
    >
      <StylesProvider jss={jss}>
        <ThemeProvider theme={theme}>
          <Init />
        </ThemeProvider>
      </StylesProvider>
    </IntlProvider>
  )
})

const container = document.getElementById('app')
const root = createRoot(container)
root.render(
  <StoreProvider>
    <App />
  </StoreProvider>
)
